export default __webpack_public_path__ + "static/media/login-banner-2-wixshopify.48c9754a.png";